module.exports = __webpack_public_path__ + "static/media/twitter.a816527f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/site-render/src/FooterSection/twitter.svg
// module id = 1082
// module chunks = 1